<template>
  <div class="Statistics">
    <div class="left_box">
      <DataSat></DataSat>
      <Share></Share>
    </div>
    <div class="right_box">
      <DataStatistics :StatisticsData="StatisticsData"></DataStatistics>
      <Special></Special>
    </div>
  </div>
</template>

<script>
export default {
  props:['StatisticsData'],
  components: {
    DataSat: () => import("@/components/DataServer/Statistics/DataSat.vue"),
    Share: () => import("@/components/DataServer/Statistics/Share.vue"),
    Special: () => import("@/components/DataServer/Statistics/Special.vue"),
    DataStatistics: () =>
      import("@/components/DataServer/Statistics/DataStatistics.vue"),
  },
};
</script>

<style lang="scss" scoped>
.Statistics {
  width: 100%;
  margin: 24px auto;
  display: flex;
  flex-direction: row;
  .left_box {
    width: 70%;
  }
  .right_box {
    background: #fff;
    border-radius: 8px;
    padding: 20px 10px 0;
    flex: 1;
    margin-left: 15px;
  }
}
</style>